module.exports = __webpack_public_path__ + "img/GAME_MINHWATU1.b47745b2.jpg";